// import React, { useState, useEffect } from 'react';
// import { FaShoppingBasket } from "react-icons/fa";
// import { Alerts, GetCart } from '../../../helpers';
// import MUIDataTable from "mui-datatables";
// import TimeAgo from '../../../components/partials/TimeAgo';
// import { Checkbox } from '@mui/material';

// const Carts = () => {
//   const [cartItems, setCartItems] = useState([]);
//   const [isLoading, setLoading] = useState(true);
//   const [selectedIds, setSelectedIds] = useState([]);
//   const [groupedItems, setGroupedItems] = useState({ regular: [], bulkGroups: [] });
//   const [isSending, setSending] = useState(false);

//   const getCartItems = async () => {
//     const resp = await GetCart.getCartItems();
//     console.log(resp);
//     if (resp && resp.status) {
//       setCartItems(resp.cartItems);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getCartItems();
//   }, []);


//   const handleRowSelect = (id) => {
//     setSelectedIds(prev =>
//       prev.includes(id)
//         ? prev.filter(itemId => itemId !== id)
//         : [...prev, id]
//     );
//   };


//   const handleSelectAll = () => {
//     if (selectedIds.length === cartItems.length) {
//       setSelectedIds([]);
//     } else {
//       setSelectedIds(cartItems.map(item => item.id));
//     }
//   };


//   const CustomHeaderCheckbox = () => (
//     <Checkbox
//       onChange={handleSelectAll}
//       checked={selectedIds.length === cartItems.length && cartItems.length > 0}
//       indeterminate={selectedIds.length > 0 && selectedIds.length < cartItems.length}
//     />
//   );


//   const CustomRowCheckbox = ({ rowIndex }) => {
//     const id = cartItems[rowIndex]?.id;
//     return (
//       <Checkbox
//         checked={selectedIds.includes(id)}
//         onChange={() => handleRowSelect(id)}
//       />
//     );
//   };

//   const columns = [
//     {
//       name: 'SL',
//       options: {
//         customHeadRender: () => <div style={{marginLeft:10}}><CustomHeaderCheckbox /></div>,
//         customBodyRender: (value, tableMeta) => (
//           <div style={{ display: 'flex', alignItems: 'center' }}>
//             <CustomRowCheckbox rowIndex={tableMeta.rowIndex} />
//             <span style={{ marginLeft: 8 }}>{value}</span>
//           </div>
//         ),
//       }
//     },
//     {
//       name: 'Product',
//       sortable: true,
//     },
//     {
//       name: 'Items in Cart',
//       sortable: true,
//     },
//     {
//       name: 'Cart Total',
//       sortable: true,
//     },
//     {
//       name: 'User',
//     },
//     {
//       name: 'Last Updated',
//     },
//       {
//       name: 'Email Status',
//     },
//     {
//       name: 'Actions',
//       sortable: false,
//     },
//   ];

// const options = {
//   filter: false,
//   download: false,
//   print: false,
//   selectableRows: 'none',
//   rowsSelected: selectedIds
//     .map(id => cartItems.findIndex(item => item.id === id))
//     .filter(index => index !== -1),
// };


//   const handleMultiCartSendEmail = async (ids)=>{
//     setSending(true)
//     const resp = await GetCart.sendAbandonmentEmail({cartIds:ids})
//     if(resp && resp.status){
//          Alerts.alertMessage(resp.message, 'top-center', 'success');
//          setSending(false);
//          getCartItems();
//          setSelectedIds([]);
//     }
    
//   }

//     useEffect(() => {
//         if (cartItems && cartItems.length > 0) {
//             const bulkGroupsMap = {};
//             const regularItems = [];

//             cartItems.forEach(item => {
//                 const cart = item;

//                 if (cart.is_bulk_order && cart.truck_group_id) {
//                     if (!bulkGroupsMap[cart.truck_group_id]) {
//                         bulkGroupsMap[cart.truck_group_id] = {
//                             truck_group_id: cart.truck_group_id,
//                             order_type: cart.order_type,
//                             items: [],
//                         };
//                     }
//                     bulkGroupsMap[cart.truck_group_id].items.push(item);
//                 } else {
//                     regularItems.push(item);
//                 }
//             });

//             const bulkGroups = Object.values(bulkGroupsMap);
//             setTimeout(() => {
//                 setGroupedItems({ regular: regularItems, bulkGroups });
//             }, 200);
//         } else {
//             setGroupedItems({ regular: [], bulkGroups: [] });
//         }
//     }, [cartItems]);



//     const toTitleCase = (str) => {
//         return str
//             .split('_')
//             .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//             .join(' ');
//     };

// console.log(groupedItems);
//   return (
//     <div className="innerPageWrapper">
//       <div className='container-fluid'>
//         <div className='page-title'>
//           <h2><FaShoppingBasket /> Cart</h2>
//         </div>
//         {isLoading ? (
//           <div className='loader'>
//             <img src='/images/loader.gif' alt='loader' />
//           </div>
//         ) : (
//           <>
//             {selectedIds.length > 0 && (
//               <div className="selected-actions" style={{
//                 marginTop: '20px',
//                 padding: '10px',
//                 backgroundColor: '#f5f5f5',
//                 borderRadius: '4px'
//               }}>
//                 <p style={{ display: 'inline-block', marginRight: '15px' }}>
//                   <strong>{selectedIds.length}</strong> item(s) selected
//                 </p>
//                 <button
//                   className="btn btn-primary btn-sm"
//                   onClick={() => handleMultiCartSendEmail(selectedIds)}
//                   style={{ marginRight: '10px' }}
//                   disabled={isSending}
//                 >
//                 {isSending ? 'Please wait..' : 'Send Reminder'}  
//                 </button>

//               </div>
//             )}
//             <MUIDataTable
//               title=""
//               data={cartItems.map((item, i) => {
//                return [
//                 i + 1, 
//                 <div style={{ maxWidth: "300px", display: 'flex', alignItems: 'center', gap: 10 }}>
//                   {item.variation_product ? item.variation_product.variation_galleries.length > 0 ?
//                     <img src={item.variation_product.variation_galleries[0].media_file.path} alt='' style={{ width: "80px" }} /> :
//                     <img src={item.variation_product.variation_main_image.path} alt='' style={{ width: "80px" }} /> : item.product ? <img src={item.product.product_thumbnail.path} alt='' style={{ width: "80px" }} /> : null }
//                   <div>
//                     <p>{item.product !== null ? item.product.title : item.variation_product.variation_content?.title}</p>
//                     <p style={{ marginTop: 7 }}><strong>SKU : {item.product_sku}</strong></p>
//                   </div>
//                 </div>,
//                 `${item.quantity} Items`,
//                 // `£ ${item.variation_product.sale_price * item.quantity}`,
//                 <div style={{ width: "150px" }}>
//                   <p>{item.user?.name}</p>
//                   <p>{item.user?.email}</p>
//                 </div>,
//                 <TimeAgo date={item.updatedAt} />,
//                   item.email_status ? <div className={`badge bg-success`}>   Sent at - <TimeAgo date={item.reminder_sent_at} />
//                   </div> : <div className={`badge bg-warning`}> Pending
//                   </div>
//                  ,
//                 <div style={{ width: "150px" }}>
//                   <button className='btn btn-info btn-sm' onClick={()=>handleMultiCartSendEmail([item.id])}>Send Reminder</button>
//                 </div>,
//               ]
//               }
//                )}
//               columns={columns}
//               options={options}
//             />


//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Carts;




// --- IMPORTS ---
import React, { useState, useEffect } from 'react';
import { FaShoppingBasket } from "react-icons/fa";
import { Alerts, GetCart } from '../../../helpers';
import MUIDataTable from "mui-datatables";
import TimeAgo from '../../../components/partials/TimeAgo';
import { Checkbox } from '@mui/material';

// ----------------------------------------

const Carts = () => {
  const [cartItems, setCartItems] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  const [groupedItems, setGroupedItems] = useState({ regular: [], bulkGroups: [] });
  const [isSending, setSending] = useState(false);

  // ==================== FETCH CART ITEMS ====================
  const getCartItems = async () => {
    const resp = await GetCart.getCartItems();
    console.log(resp);
    if (resp && resp.status) {
      setCartItems(resp.cartItems);
      setLoading(false);
    }
  };

  useEffect(() => { getCartItems(); }, []);

  // ==================== GROUP LOGIC ====================
  useEffect(() => {
    if (!cartItems || cartItems.length === 0) {
      setGroupedItems({ regular: [], bulkGroups: [] });
      return;
    }

    const bulkGroupsMap = {};
    const regularItems = [];

    cartItems.forEach(item => {
      if (item.is_bulk_order && item.truck_group_id) {
        if (!bulkGroupsMap[item.truck_group_id]) {
          bulkGroupsMap[item.truck_group_id] = {
            truck_group_id: item.truck_group_id,
            order_type: item.order_type,
            items: [],
          };
        }
        bulkGroupsMap[item.truck_group_id].items.push(item);
      } else {
        regularItems.push(item);
      }
    });

    setGroupedItems({
      regular: regularItems,
      bulkGroups: Object.values(bulkGroupsMap)
    });
  }, [cartItems]);

  // ==================== SELECTION CHECKBOX ====================
  const handleRowSelect = (id) => {
    setSelectedIds(prev =>
      prev.includes(id)
        ? prev.filter(itemId => itemId !== id)
        : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedIds.length === cartItems.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(cartItems.map(item => item.id));
    }
  };

  const CustomHeaderCheckbox = () => (
    <Checkbox
      onChange={handleSelectAll}
      checked={selectedIds.length === cartItems.length && cartItems.length > 0}
      indeterminate={selectedIds.length > 0 && selectedIds.length < cartItems.length}
    />
  );

  const CustomRowCheckbox = ({ rowIndex }) => {
    const id = tableFlatItems[rowIndex]?.id;
    return (
      <Checkbox
        checked={selectedIds.includes(id)}
        onChange={() => handleRowSelect(id)}
      />
    );
  };

  // ==================== REMINDER (EMAIL) ====================
  const handleMultiCartSendEmail = async (ids) => {
    setSending(true);
    const resp = await GetCart.sendAbandonmentEmail({ cartIds: ids });

    if (resp && resp.status) {
      Alerts.alertMessage(resp.message, 'top-center', 'success');
      setSending(false);
      getCartItems();
      setSelectedIds([]);
    }
  };

  // ==================== UI HELPERS ====================
  const formatOrderType = (type) =>
    type ? type.split("_").map(w => w[0].toUpperCase() + w.slice(1)).join(" ") : "";

  const renderProduct = (item) => (
    <div style={{ maxWidth: "300px", display: 'flex', alignItems: 'center', gap: 10 }}>
      {item.variation_product
        ? item.variation_product.variation_galleries.length > 0
          ? <img src={item.variation_product.variation_galleries[0].media_file.path} style={{ width: 80 }} />
          : <img src={item.variation_product.variation_main_image.path} style={{ width: 80 }} />
        : item.product
          ? <img src={item.product.product_thumbnail.path} style={{ width: 80 }} />
          : null
      }
      <div>
        <p>{item.product ? item.product.title : item.variation_product?.variation_content?.title}</p>
        <p style={{ marginTop: 7 }}><strong>SKU : {item.product_sku}</strong></p>
      </div>
    </div>
  );

  const renderUser = (item) => (
    <div style={{ width: "150px" }}>
      <p>{item.user?.name}</p>
      <p>{item.user?.email}</p>
    </div>
  );

  const renderEmailStatus = (item) =>
    item.email_status ? (
      <div className="badge bg-success">
        Sent at - <TimeAgo date={item.reminder_sent_at} />
      </div>
    ) : (
      <div className="badge bg-warning">Pending</div>
    );

  const renderActions = (item) => (
    <button
      className="btn btn-info btn-sm"
      onClick={() => handleMultiCartSendEmail([item.id])}
    >
      Send Reminder
    </button>
  );

  // ============================================================
  // BUILD TABLE DATA
  // ============================================================

  let tableData = [];
  let tableFlatItems = [];

  // ---------- 1️⃣ REGULAR ITEMS ----------
  groupedItems.regular.forEach((item, index) => {
    tableFlatItems.push(item);
    tableData.push([
      index + 1,
      renderProduct(item),
      `${item.quantity} Items`,
      renderUser(item),
      <TimeAgo date={item.updatedAt} />,
      renderEmailStatus(item),
      renderActions(item),
    ]);
  });

  // ---------- 2️⃣ BULK GROUPS ----------
  groupedItems.bulkGroups.forEach((group, groupIndex) => {
    const isBulkType =
      group.order_type === "full_truck" ||
      group.order_type === "half_truck";

    // ----- GROUP HEADER ROW -----
    tableData.push([
      // <strong style={{ color: "blue" }}>
      //   Truck Group #{group.truck_group_id}
      // </strong>,
      <span></span>,
       <div className="badge bg-info">
        {formatOrderType(group.order_type)}
      </div>,
      <strong>{group.items.length} items</strong>,
      "—",
      "—",
      "—",
      // ---- SINGLE REMINDER BUTTON FOR THE WHOLE TRUCK GROUP ----
      isBulkType ? (
        <button
          className="btn btn-warning btn-sm"
          style={{minWidth:120}}
          onClick={() => handleMultiCartSendEmail(group.items.map(i => i.id))}
        >
          Send Reminder
        </button>
      ) : "—"
    ]);

    // ----- CHILD ITEMS -----
    group.items.forEach((item, index) => {
      tableFlatItems.push(item);
      tableData.push([
        `${groupIndex + 1}.${index + 1}`,
        renderProduct(item),
        `${item.quantity} Items`,
        renderUser(item),
        <TimeAgo date={item.updatedAt} />,
        renderEmailStatus(item),
        renderActions(item),
      ]);
    });
  });

  // ==================== TABLE COLUMNS ====================
  const columns = [
    {
      name: 'SL',
      options: {
        customHeadRender: () => <div style={{ marginLeft: 10 }}><CustomHeaderCheckbox /></div>,
        customBodyRender: (value, tableMeta) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CustomRowCheckbox rowIndex={tableMeta.rowIndex} />
            <span style={{ marginLeft: 8 }}>{value}</span>
          </div>
        ),
      }
    },
    "Product",
    "Items in Cart",
    "User",
    "Last Updated",
    "Email Status",
    "Actions"
  ];

  const options = {
    filter: false,
    download: false,
    print: false,
    selectableRows: 'none',
  };

  // ==================== RENDER UI ====================

  return (
    <div className="innerPageWrapper">
      <div className='container-fluid'>
        <div className='page-title'>
          <h2><FaShoppingBasket /> Cart</h2>
        </div>

        {isLoading ? (
          <div className='loader'>
            <img src='/images/loader.gif' alt='loader' />
          </div>
        ) : (
          <>
            {selectedIds.length > 0 && (
              <div
                className="selected-actions"
                style={{
                  marginTop: '20px',
                  padding: '10px',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                }}
              >
                <p style={{ display: 'inline-block', marginRight: '15px' }}>
                  <strong>{selectedIds.length}</strong> item(s) selected
                </p>

                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => handleMultiCartSendEmail(selectedIds)}
                  disabled={isSending}
                >
                  {isSending ? 'Please wait..' : 'Send Reminder'}
                </button>
              </div>
            )}

            <MUIDataTable
              title=""
              data={tableData}
              columns={columns}
              options={options}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Carts;
